import React from 'react'
import logo from '../logo.svg'

const NavPages = () => {
  return (
    <header className='bg-lite'>
      <div className="s-10"></div>
      <h1 id='logo' className='flex jcc ai'>
        <a href='/' aria-label='Logotype'>
          <img src={logo} width={200} height={80} alt='CrypCons' />
        </a>
      </h1>
      <div className="s-10"></div>
    </header>
  )
}

export { NavPages }
